import { assert_false, assert_string_object_id_not_empty, not_implemented } from '@shared/asserts/utils_asserts';
import { assert_string_uuid_not_empty } from '@shared/asserts/utils_asserts_string';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { timestamp_ms } from '@shared/utils/utils_time';
import { DTO__image_asset } from '../../image_asset_base/DTO__image_asset';
import { DTO_IMAGE_META__base } from '../_base/DTO_IMAGE_META__base';

export class DTO_IMAGE_META__graph_field extends DTO_IMAGE_META__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.IMAGE_META__GRAPH_FIELD;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */

  graph_id!: string;
  node_id!: string;
  field_id!: string;

  /*
   * RUNTIME FIELDS
   */

  /*
   * PROPERTIES
   */

  get graph_node_row_hash() {
    not_implemented();
    return '';

    /*
    // todo:use

    let out: string = '';
  
      switch (this.image_meta__master.source_type) {
        case ENUM__image_source_type.MASK_GENERATED:
        case ENUM__image_source_type.CROPPED:
        case ENUM__image_source_type.UPLOADED:
          out = this.image_meta__master.hash_sha256_content;
          break;
        case ENUM__image_source_type.GENERATED:
        case ENUM__image_source_type.GENERATE_IN_FUTURE:
          assert_instanceof(this.image_meta__master, DTO_IMAGE_META__graph_field_node_output_base);
          out = this.image_meta__master.field_hash__value_full;
          break;
        case ENUM__image_source_type.UNKNOWN:
          out = ENUM__string_id_empty.HASH_SHA256;
          break;
        default:
          not_implemented_type(this.image__master.source_type);
      }
  
      assert_string_hash_sha256(out);
  
      return out;
     */
  }

  /*
   * METHODS
   */
  constructor() {
    super();
  }

  init_for_field_and_role(field: FIELD__image_asset) {
    this.init_as_new();
    this.init_for_field(field);
  }

  //todo:merge with init_as_new_and_role
  init_as_new() {
    assert_false(this.is_stub());

    let timestamp = timestamp_ms();

    [this.workspace_id, this.user_id_creator] = [ENUM__string_id_empty.OBJECT_ID, ENUM__string_id_empty.OBJECT_ID];
    [this.updated_at, this.created_at] = [timestamp, timestamp];

    this._id = ENUM__string_id_empty.OBJECT_ID;
  }

  init_for_field_and_asset(field: FIELD__image_asset, image: DTO__image_asset) {
    this.init_for_field(field);

    this.hash_sha256_content = image.hash_sha256_content;
  }

  init_for_field(field: FIELD__image_asset) {
    this.graph_id = assert_string_object_id_not_empty(field.meta.graph_id);
    this.node_id = assert_string_uuid_not_empty(field.meta.node_id);
    this.field_id = assert_string_uuid_not_empty(field.meta.field_id);
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_object_id_not_empty(this.graph_id);
    assert_string_uuid_not_empty(this.node_id);
    assert_string_uuid_not_empty(this.field_id);
  }
}
